<template>
  <div class="w-full h-full py-4 lg:py-6">
    <div
      class="w-full flex 2xl:gap-5 justify-between lg:justify-end py-2 gap-2 lg:gap-4"
    >
      <!-- <div class="">
        <form
          @submit.prevent="serachEmailTemplate(emailSearch)"
          class="flex gap-x-5"
        >
          <input
            type="text"
            class="rounded-lg border px-2 py-2 outline-none capitalize"
            placeholder="Search Names Here"
            name=""
            v-model="emailSearch"
            id="search_email"
          />
          <button
            type="submit"
            class="bg-gradient-to-r from-blue-500 to-[#2563EB] capitalize text-white hover:bg-gradient-to-l hover:from-blue-500 hover:to-[#2563EB] font-bold px-2 2xl:px-4 h-[36px] 2xl:h-[42px] flex items-center rounded-lg"
          >
            Submit
          </button>
        </form>
      </div> -->
      <div class="flex items-center">
        <form @submit.prevent="searchEmail" class="flex gap-2 lg:gap-4 w-full">
          <input
            type="text"
            name="email_search"
            id="email_search"
            placeholder="Search by name"
            v-model="email_search"
            class="rounded-lg w-[70%] lg:w-[240px]"
          />
          <button type="submit" class="btn text-sm px-4 py-2 rounded-lg">
            Search
          </button>
        </form>
      </div>

      <button @click="addEmailTemplate = true" class="btn px-4 py-2 rounded-lg">
        Add+
      </button>

      <!-- Email template -->
    </div>
    <!-- email template list -->
    <div v-if="loader == false">
      <div v-if="emailList.length > 0" class="w-full overflow-x-scroll">
        <table class="min-w-full bg-primary2 shadow-md">
          <thead class="bg-primary border-b text-start sticky top-0 text">
            <tr class="text-left whitespace-nowrap">
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                S.No
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Campaign Name
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Subject
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Body
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="emailList.length <= 0">
              <td></td>
              <td class="px-4 py-2 xl:px-6 xl:py-4 text-left">{{ message }}</td>
            </tr>
            <tr
              v-else
              class="text-left border-b whitespace-nowrap"
              v-for="(email, index) in emailList"
              :key="index"
            >
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                {{ (currentPage - 1) * perPage + index + 1 }}
              </td>
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                {{ email.campaign.name }}
              </td>
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                <p>{{ email.subject }}</p>
              </td>
              <td
                class="px-4 py-2 xl:px-6 xl:py-4 cursor-pointer"
                @click="openPopUp(email.id)"
              >
                View
              </td>

              <td class="whitespace-nowrap px-4 py-2 xl:px-6 xl:py-4 relative">
                <div class="inline-flex items-center justify-center">
                  <button
                    @click="toggleEdit(email.id)"
                    class="size-8 rounded-full mt-1 p-0 hover:bg-slate-300/20 focus:bg-slate-300/20 active:bg-slate-300/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="size-4.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                      />
                    </svg>
                  </button>
                  <div
                    class="absolute -left-[110px] top-4 w-[130px] z-50"
                    v-show="popupId === email.id"
                  >
                    <div
                      class="popper-box rounded-md border border-slate-150 bg-white py-0 font-inter dark:border-navy-500 dark:bg-navy-700"
                    >
                      <ul>
                        <li
                          @click="
                            editEmail(email.id);
                            editCampaginStatus = true;
                          "
                        >
                          <p
                            class="flex h-6 items-center px-3 pr-4 cursor-pointer font-medium tracking-wide outline-none transition-all hover:bg-[#2563eb] hover:text-white focus:bg-slate-100 focus:text-slate-800 text-xs"
                          >
                            Edit
                          </p>
                        </li>
                        <!-- <li @click="deleteCampaign(email.id, email.name)">
                      <p
                        class="flex h-6 items-center px-3 pr-4 cursor-pointer font-medium tracking-wide outline-none transition-all hover:bg-[#2563eb] hover:text-white focus:bg-slate-100 focus:text-slate-800 text-xs"
                      >
                        Delete
                      </p>
                    </li> -->
                      </ul>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="bg-primary border-b text">
            <tr class="">
              <td colspan="5" class="px-4 py-2 xl:px-6 xl:py-4">
                <div class="flex justify-between items-center w-full">
                  <h2 class="">
                    Showing {{ first_value }} to
                    {{ total_std_list.count }}
                  </h2>
                  <h2 class="">
                    Page {{ total_std_list.current_page_number }} of
                    {{ total_std_list.total_pages }}
                  </h2>
                  <div class="">
                    <button
                      v-if="email_prev"
                      @click="prevEmail"
                      class="btn px-2 py-1 rounded-md"
                    >
                      prev
                    </button>
                    <button
                      v-if="email_next"
                      @click="nextEmail"
                      class="btn px-2 py-1 rounded-md"
                    >
                      next
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-else class="" style="height: calc(100vh - 80px)">
        <div class="flex flex-col justify-center items-center h-full">
          <img
            :src="no_data"
            class="w-full h-[500px] object-contain"
            alt=""
            srcset=""
          />
          <h1 class="text-black text-lg">NO DATA FOUND</h1>
        </div>
      </div>
    </div>
    <div
      v-if="openPop"
      class="z-50 flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-80"
    >
      <div
        class="!flex justify-center !items-center w-[60%] bg-white mx-auto rounded-lg relative !z-999 p-5 overflow-y-scroll pt-5"
      >
        <button
          @click="openPop = false"
          class="absolute top-0 right-0 p-2 focus:outline-none"
        >
          <svg
            class="w-6 h-6 text-gray-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
        <div
          v-for="(email, index) in body"
          :key="index"
          class="overflow-y-scroll p-5 h-[90%]"
        >
          <div
            class="flex flex-wrap text-left"
            v-html="email.body"
            style="white-space: normal; word-wrap: break-word"
          ></div>
        </div>
      </div>
    </div>

    <!-- add email template popup  -->
    <div
      v-if="addEmailTemplate"
      class="flex items-center justify-center w-full h-full fixed top-0 left-0 z-50 bg-black bg-opacity-60"
    >
      <div
        class="bg-white p-6 gap-y-5 flex flex-col justify-center items-center w-full lg:w-[500px] rounded-xl relative !z-999"
      >
        <div class="flex justify-between w-full">
          <h2>Add Email Template</h2>
          <span
            @click="addEmailTemplate = false"
            class="font-semibold text-lg hover:text-red-700 cursor-pointer"
            >x</span
          >
        </div>

        <div class="">
          <form
            action=""
            @submit.prevent="emailTemplateCreate"
            class="flex flex-col gap-2 lg:gap-3 justify-start"
          >
            <div class="flex flex-col text-start">
              <label for="campaignName"
                >Select Campaign <span class="span-color">*</span></label
              >
              <select
                name="campaign"
                id="campaign"
                required
                v-model="selected_campaign"
                class="input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              >
                <option value="" selected disabled>Select Campaign</option>
                <option v-for="el in campaignList" :key="el.id" :value="el.id">
                  {{ el.name }}
                </option>
              </select>
            </div>
            <div class="flex flex-col text-start">
              <label for="subject"
                >Subject <span class="span-color">*</span></label
              >
              <input
                v-model="subject"
                type="text"
                placeholder="subject"
                required
                class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              />
            </div>
            <div class="flex flex-col text-start">
              <label for="campaignDescription"
                >Description <span class="span-color">*</span></label
              >
              <textarea
                name="campaignDescription"
                id="campaignDescription"
                cols="30"
                v-model="description"
                rows="10"
                placeholder="add email template"
                required
                class="border input-border rounded-md w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              ></textarea>
            </div>

            <div class="flex justify-center pt-3">
              <button type="submit" class="w-40 px-6 py-3 btn rounded-md">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- edit email template -->
    <div
      v-if="editEmailStatus == true"
      class="flex items-center justify-center w-full h-full fixed top-0 left-0 z-50 bg-black bg-opacity-60"
    >
      <div
        class="bg-white p-5 lg:p-6 gap-y-5 flex flex-col justify-center items-center w-full lg:w-[500px] rounded-xl relative !z-999"
      >
        <div class="p-2 lg:p-8 w-full text-lg h-full">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-semibold text-black">Update Email</h2>
            <span
              @click="editEmailStatus = false"
              class="font-semibold text-lg hover:text-red-700 cursor-pointer"
              >x</span
            >
          </div>
          <form
            action=""
            @submit.prevent="updateEmailTemplate"
            class="flex flex-col gap-2 lg:gap-3 justify-start"
          >
            <div class="flex flex-col text-start">
              <label for="campaignName"
                >Select Campaign <span class="span-color">*</span></label
              >
              <select
                name="campaign"
                id="campaign"
                required
                v-model="update_selected_campaign"
                class="input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              >
                <!-- <option value="" selected disabled>Select Campaign</option> -->
                <option v-for="el in campaignList" :key="el.id" :value="el.id">
                  {{ el.name }}
                </option>
              </select>
            </div>
            <div class="flex flex-col text-start">
              <label for="subject"
                >Subject <span class="span-color">*</span></label
              >
              <input
                v-model="update_subject"
                type="text"
                placeholder="update subject"
                required
                class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              />
            </div>
            <div class="flex flex-col text-start">
              <label for="campaignDescription"
                >Description <span class="span-color">*</span></label
              >
              <textarea
                name="campaignDescription"
                id="campaignDescription"
                cols="30"
                v-model="update_description"
                rows="10"
                placeholder="update email template"
                required
                class="border input-border rounded-md w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              ></textarea>
            </div>

            <div class="flex justify-center pt-3">
              <button type="submit" class="w-40 px-6 py-3 btn rounded-md">
                Submit
              </button>
            </div>
          </form>
          <!-- <div v-if="updateValue">
            <p class="text-lg font-semibold">{{ updateValue }}</p>
          </div> -->
        </div>
      </div>
    </div>
    <!-- loader start -->
    <div v-if="loader" class="flex flex-col justify-center items-center">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      Loading...
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      loader: false,
      addEmailTemplate: false,
      editEmailStatus: false,
      editEmailStatus: false,
      openPop: false,
      popupId: "",
      emailList: [],
      campaignList: [],
      updatedEmail: [],
      selected_campaign: "",
      description: "",
      subject: "",
      update_selected_campaign: "",
      update_description: "",
      update_subject: "",
      currentPage: 1,
      perPage: 20,
      body: "",
      email_id: "",
      no_data: require(`${process.env.VUE_APP_NODATA}`),
      email_search: "",
      total_std_list: "",
      email_next: "",
      email_prev: "",
      current_page_number: "",
      total_pages: "",
      first_value: 1,
      last_value:20,
    };
  },
  async created() {
    this.loader = true;
    await this.getEmail();
    await this.getCampaign();
  },
  computed: {
    ...mapGetters(["userInfo", "isAuthenticated"]),
  },
  methods: {
    toggleEdit(id) {
      if (this.popupId === id) {
        this.popupId = null;
      } else {
        this.popupId = id;
      }
    },
    async getCampaign() {
      axios
        .get(
          `${process.env.VUE_APP_API}/campaign/list/?Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.data.status == 200) {
            this.campaignList = resp.data.data.data;
            this.message = resp.data.data.message;
          }
        })
        .catch((err) => {
          console.log("error ", err);
        });
    },
    async nextEmail() {
      await axios
        .get(`${this.email_next}`)
        .then((resp) => {
          this.total_std_list = resp.data;
          this.recipientList = resp.data.data;
          this.email_next = resp.data.next;
          this.email_prev = resp.data.previous;
          this.current_page_number = resp.data.current_page_number;
          this.first_value = (this.current_page_number - 1) * 20 + 1;
          this.last_value = this.current_page_number * 20;
          this.total_pages = resp.data.total_pages;
          this.loader = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // previous email list
    async prevEmail() {
      await axios
        .get(`${this.email_prev}`)
        .then((resp) => {
          this.total_std_list = resp.data;
          this.recipientList = resp.data.data;
          this.email_next = resp.data.next;
          this.email_prev = resp.data.previous;
          this.current_page_number = resp.data.current_page_number;
          this.total_pages = resp.data.total_pages;
          this.first_value = (this.current_page_number - 1) * 20 + 1;
          this.last_value = (this.last_value / 20 - 1) * 20;
          this.loader = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getEmail() {
      axios
        .get(
          `${process.env.VUE_APP_API}/email-template/list/?Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.data.status == 200) {
            this.emailList = resp.data.data.data;
            this.message = resp.data.data.message;
            this.total_std_list = resp.data;
            this.email_next = resp.data.next;
            this.email_prev = resp.data.previous;
            this.current_page_number = resp.data.current_page_number;
            this.total_pages = resp.data.total_pages;
            setTimeout(() => {
              this.loader = false;
            }, 1000);
          } else if (resp.data.data.status == 400) {
            setTimeout(() => {
              this.loader = false;
            }, 1000);
          }
        })
        .catch((err) => {
          console.log("error ", err);
        });
    },
    // search email
    searchEmail() {
      axios
        .get(
          `${process.env.VUE_APP_API}/email-template/list/?search=${this.email_search}&Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.data.status == 200) {
            this.emailList = resp.data.data.data;
            this.message = resp.data.data.message;
            setTimeout(() => {
              this.loader = false;
            }, 1000);
          } else if (resp.data.data.status == 400) {
            setTimeout(() => {
              this.loader = false;
            }, 1000);
          }
        })
        .catch((err) => {
          console.log("error ", err);
        });
    },
    emailTemplateCreate() {
      const templateData = {
        campaign: this.selected_campaign,
        subject: this.subject,
        body: this.description,
      };
      console.log("templateData", templateData);
      axios
        .post(
          `${process.env.VUE_APP_API}/email-template-create/post/?Key=${this.userInfo.data.token}`,
          templateData
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.addEmailTemplate = false;
            this.getEmail();
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    // edit email template
    editEmail(id) {
      this.email_id = id;
      this.editEmailStatus = true;
      axios
        .get(
          `${process.env.VUE_APP_API}/email-template/list/?id=${id}&Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.data.status == 200) {
            this.updatedEmail = resp.data.data.data;
            this.update_selected_campaign = this.updatedEmail[0].campaign.id;
            this.update_subject = this.updatedEmail[0].subject;
            this.update_description = this.updatedEmail[0].body;
            this.message = resp.data.data.message;
            this.popupId = "";
          }
        })
        .catch((err) => {
          console.log("error ", err);
        });
    },
    updateEmailTemplate() {
      const templateData = {
        campaign: this.update_selected_campaign,
        subject: this.update_subject,
        body: this.update_description,
      };
      axios
        .put(
          `${process.env.VUE_APP_API}/email-template/update-destroy/${this.email_id}/?Key=${this.userInfo.data.token}`,
          templateData
        )
        .then((resp) => {
          if (resp.status == 200) {
            this.editEmailStatus = false;
            this.getEmail();
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    openPopUp(id) {
      this.openPop = true;
      this.body = this.emailList.filter((email) => email.id === id);
    },
  },
};
</script>

<style></style>
